import type { Entity } from '@backstage/catalog-model';
import {
  isStackDeletingOrDeleted,
  isStackV1Entity,
} from '@internal/plugin-stack-common';
import type { LogSourcePlatform } from './logSourceValidation';

// Listed here rather than read from capabilities, which are a closed set owned by the orchestrator.
// azure-vm and azure-windows-vm are left out on purpose: they have no config puller, so a registration would never reach the guest.
const LOG_SOURCE_PLATFORMS: Record<string, LogSourcePlatform> = {
  'cloudstack-vm': 'linux',
  'vm-service': 'linux',
  'postgres-vm': 'linux',
  'rabbitmq-vm': 'linux',
  'windows-vm': 'windows',
};

export function logSourcePlatformOf(
  stackType: string,
): LogSourcePlatform | undefined {
  return LOG_SOURCE_PLATFORMS[stackType.toLowerCase()];
}

export function showsLogSourcesTab(entity: Entity): boolean {
  return (
    isStackV1Entity(entity) &&
    logSourcePlatformOf(entity.spec.stackType) !== undefined &&
    !isStackDeletingOrDeleted(entity)
  );
}
